import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Wrench, Globe } from 'lucide-react';
export function Slide17GoToMarket() {
  const steps = [{
    icon: Rocket,
    title: 'Pilot Launch (Q1)',
    desc: '5 brands, 10+ partners, test MVP'
  }, {
    icon: Wrench,
    title: 'Pre-Launch',
    desc: 'Feature dev, more brands, Co-Brand national'
  }, {
    icon: Globe,
    title: 'National Launch',
    desc: 'Full app, expanded network, vending machines'
  }];
  return <div className="flex flex-col h-full justify-center max-w-7xl mx-auto w-full" data-id="element-209">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-210">
        Go-To-Market (3 Steps)
      </motion.h2>

      <div className="relative" data-id="element-211">
        {/* Timeline Line */}
        <motion.div className="absolute top-12 left-0 right-0 h-1 bg-white/10" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.5
      }} data-id="element-212" />

        <div className="grid grid-cols-3 gap-8 relative z-10" data-id="element-213">
          {steps.map((step, i) => <motion.div key={i} initial={{
          y: 50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: i * 0.4,
          type: 'spring'
        }} className="flex flex-col items-center text-center" data-id="element-214">
              <div className="w-24 h-24 rounded-full bg-[#0a4d4d] border-4 border-[#4fd1c5] flex items-center justify-center mb-8 shadow-xl" data-id="element-215">
                <step.icon className="w-10 h-10 text-[#ffd700]" data-id="element-216" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-217">
                {step.title}
              </h3>
              <p className="text-lg text-white/70 max-w-xs" data-id="element-218">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}